// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FSatvnPmF0hqKaQ1xY61{padding-right:20px}.JTi4WOJznH41JoZu5PvI{margin-bottom:56px}.FRp5dglnu8oJ1b2zY4Ie{justify-content:space-between;align-items:center;gap:12px;width:100%;min-height:51px;display:flex}.RmfzcEug9JUjdhg0iEUs{padding-top:20px;padding-bottom:20px}.kc0t35h6S8tKHX3ds5oE{align-items:center;margin-left:auto;display:flex}.vOpD_PaXCEMIfUtjd3BC{text-align:center;flex:none;min-width:72px;padding:2px 5px 5px}.iT78HZlCqM9PnHpG93So{flex:none;justify-content:center;align-items:center;min-width:72px;display:flex}.Fsoe8Cv2nCsGIBIZ83CR{vertical-align:middle;margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FSatvnPmF0hqKaQ1xY61`,
	"permissionsWrap": `JTi4WOJznH41JoZu5PvI`,
	"permissionContent": `FRp5dglnu8oJ1b2zY4Ie`,
	"blockHeader": `RmfzcEug9JUjdhg0iEUs`,
	"blockHeaderRoles": `kc0t35h6S8tKHX3ds5oE`,
	"roleNamesItem": `vOpD_PaXCEMIfUtjd3BC`,
	"roleInputs": `iT78HZlCqM9PnHpG93So`,
	"permissionTooltip": `Fsoe8Cv2nCsGIBIZ83CR`
};
export default ___CSS_LOADER_EXPORT___;
